export default "__VITE_ASSET__WATNR$ge__"